import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
let bodyElement = null;
/**
 * Listen when the filmstrip is visible.
 */
StateListenerRegistry.register(state => state['features/filmstrip'].visible, 
/* listener */ visible => {
    if (!bodyElement) {
        bodyElement = document.body;
    }
    if (visible) {
        bodyElement?.classList?.add('filmstrip-visible');
    }
    else {
        bodyElement?.classList?.remove('filmstrip-visible');
    }
});
